interface Props {
  [key: string]: any
}

export default function VideoIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 20 14" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `stroke-current ${pathClassName}` : ''}
        d="M13 5L17.553 2.724C17.7054 2.64784 17.8748 2.61188 18.045 2.61955C18.2152 2.62721 18.3806 2.67825 18.5256 2.76781C18.6706 2.85736 18.7902 2.98248 18.8733 3.13127C18.9563 3.28007 18.9999 3.44761 19 3.618V10.382C18.9999 10.5524 18.9563 10.7199 18.8733 10.8687C18.7902 11.0175 18.6706 11.1426 18.5256 11.2322C18.3806 11.3218 18.2152 11.3728 18.045 11.3805C17.8748 11.3881 17.7054 11.3522 17.553 11.276L13 9V5ZM3 13H11C11.5304 13 12.0391 12.7893 12.4142 12.4142C12.7893 12.0391 13 11.5304 13 11V3C13 2.46957 12.7893 1.96086 12.4142 1.58579C12.0391 1.21071 11.5304 1 11 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V11C1 11.5304 1.21071 12.0391 1.58579 12.4142C1.96086 12.7893 2.46957 13 3 13Z"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}
